<template>
	<!-- 异常订单 -->
	<div class="billOperationRecord public_Spacing report-statistics-page">
		<div class="pulbic_oparetionBlock report-filter-panel" style="margin-bottom: 12px;">
			<div class="report-filter-head">
					<div>
						<div class="report-filter-title">筛选条件</div>
						<div class="report-filter-subtitle">按企业、物料和时间范围查看报表统计数据</div>
					</div>
					<div class="report-filter-range">{{ date[0] || '--' }} 至 {{ date[1] || '--' }}</div>
				</div>
				<div class="report-filter-body">
					<div class="public_criteriaRange report-filter-controls">
				<div v-shiroHiden="solelist" id="企业筛选">
					<div class="public_oparetionBlock_Menu report-filter-item">
						<label class="public_lbSty">企业：</label>
						<el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
							filterable remote :remote-method="filterEnterprise" placeholder="请选择">
							<el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID"
								:label="item.SETTB99CA00" :value="item.SETTB99ID">
							</el-option>
						</el-select>
					</div>
				</div>
				<!-- <div class="public_oparetionBlock_Menu" v-if="this.uobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">客户：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择"
						filterable>
						<el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
							:value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div> -->
				<div v-shiroHiden="solelist" id="物料筛选">
					<div class="public_oparetionBlock_Menu report-filter-item">
						<label class="public_lbSty">物料：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
							filterable :disabled="!enterpriseTwo"
							@focus="!enterpriseTwo && $message.warning('请先选择企业')">
							<el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
								:value="item.SETTB109ID">
							</el-option>
						</el-select>
					</div>
				</div>

			

			</div>
			<div class="public_operatArea report-time-controls">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''"
					@click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateLastMonthActive?'public_dateActive':''" @click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
						range-separator="至" :picker-options="startDateDisabled" @change="datePickerChange"
						start-placeholder="开始日" end-placeholder="结束日" class="pulic_cursor report-date-picker">
					</el-date-picker>
				</div>
				<div class="public_operatBtn report-action-controls">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button>
					
					<el-button class="public_saleWater_daochu pulic_cursor" :loading="loadingBut" @click="exports"
						v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>导出<span
							v-if="confirmTxt >0">{{confirmTxt}}</span></el-button>
					<el-popover ref="popover2" trigger="click">
						<div style="text-align: left;padding-left: 20px;padding-top: 8px;">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
								@change="handleCheckAllChange">全选</el-checkbox>
							<div style="margin: 15px 0;"></div>
							<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
								<el-checkbox style="display: block;" class="salesWater_checkbox" v-for="city in cities"
									:label="city" :key="city">{{city}}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-popover>
				</div>
			</div>
		</div>
		
		</div>

			<div class="billOperationRecord-table pulbic_table_container report-table-card">
				<div class="report-table-head">
					<div>
						<div class="report-table-title">统计报表</div>
						<div class="report-table-subtitle">共 {{ pagingPageMo || 0 }} 条统计记录，当前页 {{ tableData.length }} 条</div>
					</div>
					<!-- <div class="report-refresh-tag">每 60 秒自动刷新</div> -->
				</div>
				<!-- 汇总卡片 -->
				<div class="report-summary-bar" v-if="tableData.length">
					<div class="report-summary-item">
						<div class="report-summary-label">自提车次</div>
						<div class="report-summary-value report-summary-value--blue">{{ reportSummary.zt }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">配送车次</div>
						<div class="report-summary-value report-summary-value--blue">{{ reportSummary.ps }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">自提重量</div>
						<div class="report-summary-value report-summary-value--orange">{{ reportSummary.ztzl.toFixed(2) }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">配送重量</div>
						<div class="report-summary-value report-summary-value--orange">{{ reportSummary.pszl.toFixed(2) }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">飞砂金额</div>
						<div class="report-summary-value report-summary-value--green">{{ reportSummary.je.toFixed(2) }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">其他平台</div>
						<div class="report-summary-value report-summary-value--green">{{ reportSummary.cqje.toFixed(2) }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">差额</div>
						<div class="report-summary-value">{{ reportSummary.ce.toFixed(2) }}</div>
					</div>
					<div class="report-summary-divider"></div>
					<div class="report-summary-item">
						<div class="report-summary-label">余额</div>
						<div class="report-summary-value">{{ reportSummary.cjye.toFixed(2) }}</div>
					</div>
				</div>
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)', background:'rgba(184,227,255,1)', border:'1px solid #BBFFEE','font-weight':'bold'}"
				class="public_tableColumn report-main-table">
				<el-table-column prop="riqi" sortable fixed="left" label="日期">
				</el-table-column>
				<el-table-column prop="changjia" width="200" fixed="left" label="厂家">
				</el-table-column>
				<el-table-column prop="wlname" width="200" fixed="left" label="物料">
				</el-table-column>
				<el-table-column prop="checi" width="130" label="车次">
					<el-table-column prop="zt" width="65" label="自提">
						<template slot-scope="scope">
							<span>{{ scope.row.zt || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ps" width="65" label="配送">
						<template slot-scope="scope">
							<span>{{ scope.row.ps || 0 }}</span>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column prop="zl" width="130" label="重量">
					<!-- <template slot-scope="scope">
						<p>
							<span>{{scope.row.ORMTB440CA03}}</span>
						</p>
						<p style="color: #999;">
							<span>{{scope.row.ORMTB410CA02}}</span>
						</p>

					</template> -->
					<el-table-column prop="ztzl" width="65" label="自提">
						<template slot-scope="scope">
							<span>{{ scope.row.ztzl || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="pszl" width="65" label="配送">
						<template slot-scope="scope">
							<span>{{ scope.row.pszl || 0 }}</span>
						</template>
					</el-table-column>
				</el-table-column>
				
				<el-table-column prop="ORMTB440CA05" label="金额">
					<el-table-column prop="je" width="120" label="飞砂走石">
						<template slot-scope="scope">
							<span>{{ scope.row.je || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="cqje" width="120" label="其他平台">
						<template slot-scope="scope">
							<span>{{ scope.row.cqje || 0 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ce" width="120" label="差额">
						<template slot-scope="scope">
							<span>{{ scope.row.ce || 0 }}</span>
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column prop="cjye" label="余额">
					<template slot-scope="scope">
						<span>{{ scope.row.cjye || 0 }}</span>
					</template>
				</el-table-column>
				
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		createLogger
	} from 'vuex';
	import debounce from '../../api/debounce';
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
	// import { isMobileDevice } from '@/utils/device';
	/* const synth = window.speechSynthesis // 启用文本
	if(!isMobileDevice){
		const msg = new SpeechSynthesisUtterance()
	} */
	// const msg = new SpeechSynthesisUtterance()

	export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
		data() {
			return {
				weightOpt: {
					tare: '',
					gross: '',
					price: ''
				},
				dialogVisibleimg: false,
				dialogImageUrl: "",
				formdata: new FormData(),
				fileList: [],
				addimg: [],
				removeimg: [],
				ruleForm: {
					csAvatar: "",
				},
				filUrl: '/system/uploadBD',
				loadingBut: false,
				confirmTxt: 0,
				inputWeightShow: false, // 输入磅单信息弹窗
				isorderAuditText: '',
				oerderDetilsShow: false,
				ewmDetilsShow: false,
				orderAuditShow: false,
				isorderAuditShow: false,
				returnReceiptShow: false,
				uobj: this.$store.state.uobj, //登陆缓存--用户信息
				date: [], //日期
				startTime: '',
				endTime: '',
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				twolevelUserLogin: true,
				timeIndex: 0, //判断第几次切换当月时间
				sameMonthTime: '', //目前月份
				currentMonthTime: '', //目前月份--上月+1
				tableData: [],
				ORMTB440CA00: '',
				materialOptions: [],
				materialTypeValue: '',
				carNum: '',
				materielMo: '',
				materielOptions: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}],
				// 代下单
				orOptions: [{
						value: '',
						label: '全部',
					},
					{
						value: '1',
						label: '自买自提',
					},
					{
						value: '1',
						label: '含货配送',
					}
				],
				
			
				// 查询
				customerMo: '', //客户--查询		
				SETTB122CA07: '', //数据状态
				ORMTB440CA29: '', //代下单状态
				billOperationAdd: false,
				enterpriseTwoOptionList: [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}], //二级企业下拉框--新增
				enterpriseTwo: '', //二级企业
				carNumber: '', //车牌号
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 列设置
				checkAll: true,
				checkedCities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
      filteredEnterpriseOptions: [],
				cities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
				isIndeterminate: false,
				// 详情
				billOperationDetails: false,
				detailsList: '', //详情列表
				ewmdetailsList: '', //详情列表
				tableHeadList: [
					

					{
						prop: 'ORMTB440CA01',
						label: '车牌号'
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料'
					},
					
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					
				],
				tableHeadListInit: [{
						prop: 'ORMTB440CA19',
						label: '派单时间',
					},
					{
						prop: 'ORMTB440CA00',
						label: '派单编号',
					},
					{
						prop: 'ORMTB440CA05',
						label: '企业名称',
					},
					{
						prop: 'ORMTB440CA03',
						label: '客户名称',
					},

					{
						prop: 'ORMTB440CA01',
						label: '车牌号',
					},
					{
						prop: 'ORMTB440CA07',
						label: '订单物料',
					},
					{
						prop: 'ORMTB440CC02',
						label: '完成物料',
					},
					{
						prop: 'ORMTB440CA10',
						label: '重量',
					},
					{
						prop: 'ORMTB440CF01text',
						label: '完成状态',
					},
					{
						prop: 'auditText',
						label: '申请状态',
					},
				],
				isRefresh: true,
				isRefreshSetInterval: '',
				// quanpDisabled: false,
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				solelist: [],
				DetailsWaterurl: '',
				DetailsWatersrcList: [],
				DetailsWeightrcList: [],
				DetailsWeightrcBDList: [],
				ewmDetails: [],
				materialList: [],
				materialValue: '',
				listTick: null, // 列表刷新定时器
				timeType: '1',
				distf: true,
				dcmoreID: '',
				dcmore: '',
			}
		},
		watch: {
			weightOpt: {
				handler(val) {
					if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
						let tare = parseFloat(val.tare)
						let gross = parseFloat(val.gross)
						this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
						if (this.detailsList.ORMTB440CC04) {
							debounce(this.getSettlementAmount, 500)
						}
					} else {
						this.detailsList.ORMTB440CC04 = ''
						this.detailsList.ORMTB440CC06 = ''
					}
				},
				deep: true
			},
			// 'detailsList.ORMTB440CA04'() {
			//     this.getSelectMaterial()
			// }
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			// console.log(list)
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
			// console.log(this.historyInfo)
			// else {
			// 	this.getNowDay();
			// }
			var path = this.$route.path;
			if (path === '/systemReportStatistics') {
				path = '/Home' + path
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表

			// console.log(this.uobj)
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}

			this.enterprise0ptions()
			this.enterprise2Options()
			this.pageList()
		},
		activated() {
		},
		deactivated() {
		},



		// 存储数据
		beforeDestroy() {
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			var obj = {
				startTime: this.startTime,
				endTime: this.endTime, //开始时间
				ORMTB440CA02: this.ORMTB440CA02, //客户id
				ORMTB400CA03: this.ORMTB400CA03, //客户名称
				ORMTB440CA04: this.ORMTB440CA04, //客户名称
				ORMTB440CA06: this.ORMTB440CA06, //二级企业id
				ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
				ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
				ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
				ORMTB440CA00: this.ORMTB440CA00
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		computed: {
			uploadDisabled: function() {
				return this.ruleForm.csAvatar != '';
			},
			reportSummary() {
				const data = this.tableData || []
				const sum = (field) => data.reduce((acc, row) => acc + (parseFloat(row[field]) || 0), 0)
				return {
					zt: sum('zt'),
					ps: sum('ps'),
					ztzl: sum('ztzl'),
					pszl: sum('pszl'),
					je: sum('je'),
					cqje: sum('cqje'),
					ce: sum('ce'),
					cjye: sum('cjye'),
				}
			},
		},
		methods: {
				startListTimer() {
					if (this.listTick) return
					this.listTick = setInterval(() => {
						if (document.hidden) return
						this.queryClick()
					}, 1000 * 60)
				},
				stopListTimer() {
					if (!this.listTick) return
					clearInterval(this.listTick)
					this.listTick = null
				},
			// 值改变 重新获取结算金额
			async materialChange(val) {
				if (val == this.detailsList.ORMTB440CC01) {
					this.weightOpt.price = this.detailsList.ORMTB440CA08
				} else {
					await this.queryMaterialPrice(val)
				}
				this.getSettlementAmount()
			},
			// 根据物料id 查询单价
			async queryMaterialPrice(ORMTB440CC01) {
				let url = '/orm/ormtb440/unitPriceAuto'
				let params = {
					ORMTB440CC01, // 结算物料id
					ORMTB440CA02: this.detailsList.ORMTB440CA02, //客户id
					ORMTB440CA04: this.detailsList.ORMTB440CA04, // 二级企业ID
				}
				params = qs.stringify(params)
				let header = {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
				let res = await this.axios.post(url, params, {
					header
				})
				if (res.data.code === 200) {
					this.weightOpt.price = res.data.data
				}
			},

			
			


			// 获取派单物料列表
			getSelectMaterial() {
				var postData = {
					SETTB99ID: this.detailsList.ORMTB440CA04
				}
				this.materialList = []
				postData = qs.stringify(postData)
				var url = "/set/settb109/select_material";
				this.axios.post(url, postData, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					if (res.data.code == 200) {
						this.materialList = res.data.data
						// this.materialValue = this.detailsList.ORMTB440CC01
						if (this.detailsList.ORMTB440CC01) {
							this.materialValue = this.detailsList.ORMTB440CC01
						} else {
							this.materialValue = this.detailsList.ORMTB440CA06
							this.queryMaterialPrice(this.materialValue)
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			//初始化数据
			init() {
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
				this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
				this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
				this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
				this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
				this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
				this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			},
			// 导出
			exports() {
				// console.log(this.uobj)
				let token = sessionStorage.getItem('token');
				if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
					this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id

				}
				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var ORMTB440CA02 = this.customerMo; //二级客户ID
				var ORMTB400CA03 = 1002; //一级客户代码
				var ORMTB440CA04 = this.enterpriseTwo; //二级企业ID
				var ORMTB440CA06 = this.materielMo; //物料ID
				var ORMTB440CF01 = this.SETTB122CA07; //状态
				var ORMTB440CA00 = this.ORMTB440CA00; //订单号
				var ORMTB440CA01 = this.carNumber; //车牌号
				var timeType = this.timeType; //
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb440toExcle?startTime=" + startTime +
					"&endTime=" +
					endTime + '&token=' + token + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
					"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
					ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00 + "&ORMTB440CA01=" + ORMTB440CA01 + "&timeType=" +
					timeType;
				window.location.href = url;

				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);

			},
		
			materielMoPost() {
				var i = (this.enterpriseTwoOptionList || []).findIndex((profile) => profile.SETTB99ID === this
					.enterpriseTwo);
				var url = "/set/settb109/selectPageList";
				var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
				var data = {
					SETTB109CA03: '',
					SETTB109CA00: '',
					SETTB109CD01: SETTB100ID,
					SETTB99ID: this.enterpriseTwo,
					page: 1,
					limit: 1000,
				};
				var List = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}];
				this.axios.post(url, data).then(res => {
					if (res.data.code == 200) {
						this.materielOptions = [...List, ...res.data.data];
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				})
			},
			erpChange() {
				if (this.enterpriseTwo != '') {
					this.materielMoPost()
				} else {
				this.materielMo = ''
					this.materielOptions = [{
						SETTB109CA00: '全部',
						SETTB109ID: '',
					}]
				}
			},
			// 查询
			queryClick() {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageList()
			},
			// 列表
			pageList() {
				// var ORMTB400CA03
				// if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				// 	ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
				// }
				// if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
				// 	ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
				// }

				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					startTime: this.startTime, //开始时间
					endTime: this.endTime, //结束时间
					// ORMTB440CA02: this.customerMo, //二级客户ID
					// ORMTB400CA03: ORMTB400CA03, //一级客户代码
					ORMTB440CA04: this.enterpriseTwo, //二级企业ID
					ORMTB440CA06: this.materielMo, //物料ID
					// ORMTB440CF01: this.SETTB122CA07, //状态
					// ORMTB440CA29: this.ORMTB440CA29, //状态
					// ORMTB440CA00: this.ORMTB440CA00, //订单号
					// ORMTB440CA01: this.carNumber, //车牌号
					// PERTB005ID: this.$store.state.uobj.pertb005.pertb005id, //角色ID
					page: this.pageMo,
					limit: this.limitMo,
					// timeType: this.timeType
				}
				this.tableData = [];
				var url = "/orm/ormtb440/selectTJ";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					// console.log(res)
					if (res.data.code == 200) {
						console.log(res)
						var data = res.data.data;
						this.pagingPageMo = res.data.count;
						this.tableData = data;
						// this.jscc = res.data.data.jscc
						// this.jsje = res.data.data.jsje
						// this.jszl = res.data.data.jszl
						// this.pdcc = res.data.data.pdcc
						// this.pdje = res.data.data.pdje
						// this.pdzl = res.data.data.pdzl
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			UploadClick(row) {
				this.ormtb440ca00 = row.ORMTB440CA00
			},
			inputFileChange(e) {
				let file = e.target.files[0]
				let formData = new FormData()
				formData.append('file', file)
				formData.append('ormtb440ca00', this.ormtb440ca00)
				let loading = this.$loading({
					lock: true,
					text: '上传中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/upload";
				this.axios.post(url, formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			inputWeightClick(row) {
				// console.log(row)
				if (row.ORMTB440CA04 == '10000108') {
					this.distf = false
					this.dcmoreID = row.ORMTB440CA04
				} else {
					this.distf = true
				}
				this.inputWeightShow = true
				// console.log(this.fileList)
				this.fileList = []
				this.ruleForm.csAvatar = ''
				this.querydetile(row)
			},
			inputWeightClose() {
				this.weightOpt.tare = ''
				this.weightOpt.gross = ''
				this.detailsList.ORMTB440CC02 = ''
				this.detailsList.ORMTB440CC02 = ''
				this.detailsList.ORMTB440CC04 = ''
				this.detailsList.ORMTB440CC06 = ''
				this.ruleForm.csAvatar = ''
			},
			// 获取结算金额
			async getSettlementAmount() {
				if (!this.materialValue) return
				if (this.weightOpt.price < 0) return
				if (!this.detailsList.ORMTB440CC04) return
				var params = {
					ORMTB440CC01: this.materialValue,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA04: this.detailsList.ORMTB440CA04,
					ORMTB440CC03: this.detailsList.ORMTB440CC03,
					ORMTB440CC04: this.detailsList.ORMTB440CC04,
					ORMTB440CC03: this.weightOpt.price
				}
				params = qs.stringify(params)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var url = "/orm/ormtb440/orderCompleteBeforeBack";
				this.axios.post(url, params, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.detailsList.ORMTB440CC06 = res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			
			inputWeightFormat(e, type) {
				let value = e.target.value
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/^\./g, ""); //验证第一个字符是数字
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				// console.log(value)
				this.weightOpt.tare = value
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				setTimeout(() => {
					this.weightOpt[type] = value
				}, 0);
			},
			inputWeightTotalFormat(e) {
				let value = e.target.value
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/^\./g, ""); //验证第一个字符是数字
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				this.detailsList.ORMTB440CC06 = value
			},
			// 详情
			DetailsClick(row) {
				this.oerderDetilsShow = true;
				this.querydetile(row)
			},
			ewmDetailsClick(row) {
				this.ewmDetilsShow = true;
				this.queryermdetile(row)
			},
			orderAudit(row) {
				this.orderAuditShow = true
				this.querydetile(row)
			},
			isorderAudit(row) {
				this.isorderAuditShow = true
				this.querydetile(row)
			},
			returnReceipt(row) {
				this.returnReceiptShow = true
				this.querydetile(row)
			},
			// 完成订单
			pushMsg(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				var url = "/orm/ormtb440/sendMsg";
				this.$confirm('此操作将推送支付消息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			completeClick(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				var url = "/orm/ormtb440/updatePayStatus";
				this.$confirm('此操作将完成该记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '操作成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			orderAuditServe(type) {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CG00: type,
					ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
					ORMTB440ID: this.detailsList.ORMTB440ID,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA11: this.detailsList.ORMTB440CA11,
					ORMTB440CA12: this.detailsList.ORMTB440CA12,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/updateORMTB440CG00";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.orderAuditShow = false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			isorderAuditServe(type) {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB440CH01: type,
					ORMTB440CH03: this.uobj.pertb005.pertb005ca02,
					ORMTB440ID: this.detailsList.ORMTB440ID,
					ORMTB440CA02: this.detailsList.ORMTB440CA02,
					ORMTB440CA11: this.detailsList.ORMTB440CA11,
					ORMTB440CA12: this.detailsList.ORMTB440CA12,
					ORMTB440CH04: this.isorderAuditText,
				}
				this.tableData = [];
				var url = "/orm/ormtb440/updateORMTB440CH01";
				this.axios.post(url, postData).then(res => {
					setTimeout(() => {
						loading.close()
					}, 400)
					if (res.data.code == 200) {
						this.$message({
							message: '审核成功',
							type: 'success'
						});
						this.isorderAuditShow = false
						this.pageList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			querydetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/selectDetails";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.detailsList = res.data.data;
						this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
						if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
							.ORMTB440CH05
						]
						if (this.detailsList.ORMTB440CL01) this.DetailsWeightrcBDList = [this.detailsList
							.ORMTB440CL01
						]
						this.DetailsWaterurl = this.detailsList.ORMTB440CE01
						if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
							this.weightOpt.price = this.detailsList.ORMTB440CC03
							if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
							this.weightOpt.tare = this.detailsList.ORMTB440CC05
							this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
								.toFixed(2)
							this.getSelectMaterial()
						}
						// else if (this.detailsList.ORMTB440CF01 == 0) {
						// 	this.weightOpt.price = this.detailsList.ORMTB440CC03
						// 	this.getSelectMaterial()
						// } 

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			queryermdetile(row) {
				var postData = {
					ORMTB440ID: row.ORMTB440ID, //流水id
				}
				this.detailsList = ''
				var url = "/orm/ormtb440/getErwei";
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.ewmdetailsList = res.data.data;
						this.ewmdetailsList.ORMTB440CA22Img = 'data:image/png;base64,' + res.data.data
							.ORMTB440CA22;

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}

				})
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? this.cities : [];
				this.isIndeterminate = false;
				this.tableHeadList = val ? this.tableHeadListInit : []
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
				var changearr = this.checkedCities;
				var initarr = this.tableHeadListInit;
				this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
			},


			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份 
					"d+": date.getDate(), //日 
					"h+": date.getHours(), //小时 
					"m+": date.getMinutes(), //分 
					"s+": date.getSeconds(), //秒 
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
					"S": date.getMilliseconds() //毫秒 
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},

			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			//获取当月时间
			sameMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上月时间
			lastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
		}
	}
</script>

<style scoped>

	.DWD-li {
		display: flex;
		height: 35px;
		line-height: 35px;
		box-sizing: border-box;
		border: 1px solid #999;
		font-size: 16px;
		color: #333;
	}

	.DWD-li>div {
		padding: 0 5px;
		height: 34px;
		overflow: hidden;
		box-sizing: border-box;
	}

	.DWD-li-title {
		width: 120px;
		text-align: center;
		border-right: 1px solid #999;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-li-text {
		flex: 1;
	}

	.DWD-li-text input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		border: none;
		outline: none;
	}

	.DWD-li+.DWD-li {
		border-top: none;
	}

	.DWD-table {
		display: flex;
	}

	.DWD-table-left-flex {
		flex: 1;
	}

	.DWD-table>div>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: center;
		border-right: 1px solid #999;
		border-bottom: 1px solid #999;
		box-sizing: border-box;
	}

	.DWD-table>div>div:first-child {
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table-left-title>div {
		width: 101px;
		text-align: center;
		background-color: rgba(0, 163, 255, .1);
	}

	.DWD-table .DWD-table-left-title>div {
		padding: 0 5px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		box-sizing: border-box;
		border-left: 1px solid #999;
		border-bottom: 1px solid #999;
	}

	.DetailsWater-img {
		margin-top: 30px;
	}

	.DetailsWater-img-text {
		display: inline-block;
		width: 101px;
		text-align: center;
		vertical-align: top;
	}

	.car-number-add {
		/* text-transform: uppercase; */
	}

	.billOperationRecord-table {
		padding: 30px 20px 0;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.pulic_operatArea_now:hover,
	.public_operatArea_yesterday:hover {
		background-color: #ccc;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 统计 START*/
	.imgStatistics {
		width: 40px;
		height: 40px;
	}

	.payType {
		font-size: 20px;
		/* font-size: 24px; */
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
	}

	.singular {
		font-size: 32px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.Amount {
		font-size: 32px;
		font-family: Microsoft YaHei;
		/* font-weight:bold; */
		line-height: 30px;
		vertical-align: middle;
		padding-left: 10px;
	}

	.pulic_statistics_titlt {
		line-height: 40px;
	}

	.Customer-upload-bd {
		padding: 20px 0;
	}

	.disabled {
		.el-upload--picture-card {
			display: none;
		}
	}


	/* 统计 END*/
.report-statistics-page {
	position: relative;
	box-sizing: border-box;
	min-height: 100%;
	padding: 16px;
	background:
		radial-gradient(circle at 88% 4%, rgba(36, 120, 232, .13), transparent 28%),
		radial-gradient(circle at 4% 34%, rgba(32, 180, 134, .11), transparent 25%),
		linear-gradient(180deg, #edf4ff 0%, #f7fafc 46%, #f9fbfd 100%);
}

.report-statistics-page::before {
	position: absolute;
	inset: 0 0 auto 0;
	height: 112px;
	content: '';
	pointer-events: none;
	background: linear-gradient(180deg, rgba(255, 255, 255, .68), rgba(255, 255, 255, 0));
}

.report-statistics-page .report-filter-panel,
.report-statistics-page .report-table-card {
	position: relative;
	z-index: 1;
	box-sizing: border-box;
	border: 1px solid rgba(205, 222, 238, .92);
	border-radius: 20px;
	background:
		linear-gradient(135deg, rgba(255, 255, 255, .98), rgba(247, 251, 255, .95)),
		radial-gradient(circle at 100% 0, rgba(36, 120, 232, .12), transparent 34%);
	box-shadow: 0 16px 36px rgba(31, 72, 110, .09);
}

.report-statistics-page .report-filter-panel {
	display: block;
	padding: 16px;
}

.report-statistics-page .report-filter-head,
.report-statistics-page .report-table-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.report-statistics-page .report-filter-head {
	margin-bottom: 14px;
	padding-bottom: 12px;
	border-bottom: 1px solid #e5eef7;
}

.report-statistics-page .report-filter-title,
.report-statistics-page .report-table-title {
	position: relative;
	padding-left: 12px;
	color: #1f3a4a;
	font-size: 18px;
	font-weight: 800;
	line-height: 24px;
}

.report-statistics-page .report-filter-title::before,
.report-statistics-page .report-table-title::before {
	position: absolute;
	left: 0;
	top: 5px;
	width: 4px;
	height: 14px;
	content: '';
	border-radius: 4px;
	background: linear-gradient(180deg, #2478e8, #20b486);
}

.report-statistics-page .report-filter-subtitle,
.report-statistics-page .report-table-subtitle {
	margin-top: 3px;
	padding-left: 12px;
	color: #7b8c98;
	font-size: 12px;
}

.report-statistics-page .report-filter-range,
.report-statistics-page .report-refresh-tag {
	padding: 8px 12px;
	border: 1px solid #dfeaf6;
	border-radius: 14px;
	background: #f7fbff;
	color: #607481;
	font-size: 12px;
	font-weight: 700;
	white-space: nowrap;
}

.report-statistics-page .report-refresh-tag {
	background: linear-gradient(135deg, #f5fbff, #ecf8f4);
	color: #2c7f69;
}

.report-statistics-page .report-filter-body {
	display: grid;
	grid-template-columns: minmax(320px, 1fr) auto;
	align-items: end;
	gap: 14px;
}

.report-statistics-page .report-filter-controls {
	display: grid;
	grid-template-columns: repeat(2, minmax(180px, 1fr));
	gap: 12px;
	min-width: 0;
	margin: 0;
	padding: 0;
}

.report-statistics-page .report-filter-controls > div,
.report-statistics-page .report-filter-item {
	min-width: 0;
}

.report-statistics-page .report-filter-item {
	display: block;
	height: auto;
	margin: 0;
}

.report-statistics-page .report-filter-item .public_lbSty {
	display: block;
	width: auto;
	height: auto;
	margin: 0 0 7px;
	color: #516674;
	font-size: 13px;
	font-weight: 800;
	line-height: 18px;
}

.report-statistics-page .report-filter-item >>> .el-select,
.report-statistics-page .report-filter-item >>> .el-input,
.report-statistics-page .report-filter-item >>> .el-input__inner {
	width: 100% !important;
}

.report-statistics-page >>> .el-input__inner,
.report-statistics-page >>> .el-date-editor {
	height: 36px;
	line-height: 36px;
	border-color: #dfe8f4;
	border-radius: 10px;
	background: #fff;
}

.report-statistics-page .report-time-controls {
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
	flex-wrap: wrap;
	gap: 8px;
	min-width: 0;
	margin: 0;
	padding: 0;
}

.report-statistics-page .pulic_operatArea_now,
.report-statistics-page .public_operatArea_yesterday {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 58px;
	height: 36px;
	padding: 0 14px;
	color: #596a7c;
	border: 1px solid #dfe8f4;
	border-radius: 10px;
	background: #fff;
	font-size: 13px;
	font-weight: 700;
	transition: all .18s ease;
}

.report-statistics-page .pulic_operatArea_now:hover,
.report-statistics-page .public_operatArea_yesterday:hover {
	color: #2478e8;
	border-color: rgba(36, 120, 232, .42);
	background: #edf6ff;
}

.report-statistics-page .public_dateActive {
	color: #fff !important;
	border-color: transparent !important;
	background: linear-gradient(135deg, #2478e8, #3db7ff) !important;
	box-shadow: 0 8px 16px rgba(36, 120, 232, .22);
}

.report-statistics-page .report-date-picker.el-date-editor--datetimerange.el-input__inner {
	width: 360px;
}

.report-statistics-page .report-action-controls {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	margin-left: 0;
}

.report-statistics-page .report-action-controls button,
.report-statistics-page .report-action-controls .el-button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	min-width: 82px;
	height: 36px;
	padding: 0 16px;
	border: 0;
	border-radius: 10px;
	color: #fff;
	font-size: 13px;
	font-weight: 800;
}

.report-statistics-page .report-action-controls .public_saleWater_chaxun {
	background: linear-gradient(135deg, #2478e8, #3db7ff) !important;
	box-shadow: 0 8px 18px rgba(36, 120, 232, .22);
}

.report-statistics-page .report-action-controls .public_saleWater_daochu {
	background: linear-gradient(135deg, #20b486, #20c997) !important;
	box-shadow: 0 8px 18px rgba(32, 180, 134, .2);
}

.report-statistics-page .report-action-controls .public_saleWater_daochu span {
	margin-left: 3px;
}

.report-statistics-page .report-table-card {
	padding: 16px 16px 0;
}

.report-statistics-page .report-table-head {
	margin-bottom: 14px;
	padding-bottom: 13px;
	border-bottom: 1px solid #e5eef7;
}

.report-statistics-page .report-summary-bar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	padding: 10px 16px;
	margin-bottom: 14px;
	background: #ffffff;
	border: 1px solid #dde9f5;
	border-radius: 10px;
	box-shadow: 0 2px 8px rgba(18, 52, 77, 0.05);
}

.report-statistics-page .report-summary-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	flex: 1;
	padding: 4px 8px;
	min-width: 0;
}

.report-statistics-page .report-summary-divider {
	width: 1px;
	height: 28px;
	background: #dde9f5;
	flex-shrink: 0;
}

.report-statistics-page .report-summary-label {
	font-size: 12px;
	font-weight: 600;
	color: #1a2e40;
	white-space: nowrap;
}

.report-statistics-page .report-summary-value {
	font-size: 18px;
	font-weight: 700;
	color: #0a1e30;
	line-height: 1;
}

.report-statistics-page .report-summary-value--blue { color: #178bff; }
.report-statistics-page .report-summary-value--orange { color: #f5720a; }
.report-statistics-page .report-summary-value--green { color: #08c98a; }

.report-statistics-page .report-main-table {
	overflow: hidden;
	border: 1px solid #e4edf7;
	border-radius: 14px;
	box-shadow: none;
}

.report-statistics-page >>> .report-main-table .el-table__header th {
	height: 48px;
	border-color: #dce8f6 !important;
	background: linear-gradient(180deg, #f7fbff, #eaf4fc) !important;
}

.report-statistics-page >>> .report-main-table .el-table__header th .cell {
	color: #2d4658;
	font-size: 15px;
	font-weight: 800;
}

.report-statistics-page >>> .report-main-table .el-table__body-wrapper td {
	height: 54px;
	border-bottom: 1px solid #eef4f9;
	color: #455a64;
	font-size: 13px;
}

.report-statistics-page >>> .report-main-table .el-table__row:hover > td {
	background-color: #f0f9ff !important;
}

.report-statistics-page >>> .report-main-table .el-table__fixed,
.report-statistics-page >>> .report-main-table .el-table__fixed-right {
	box-shadow: 6px 0 16px rgba(31, 72, 110, .06);
}

.report-statistics-page >>> .report-main-table .el-table__fixed::before,
.report-statistics-page >>> .report-main-table .el-table__fixed-right::before {
	height: 0;
}

.report-statistics-page .pulbic_pagesize {
	display: flex;
	justify-content: flex-end;
	padding: 14px 2px 16px;
	border: 0;
	background: transparent;
}

.report-statistics-page >>> .el-pagination {
	padding: 0;
}

.report-statistics-page th,
.report-statistics-page td {
	text-align: center !important;
}

@media screen and (max-width: 1360px) {
	.report-statistics-page .report-filter-body {
		grid-template-columns: 1fr;
	}

	.report-statistics-page .report-time-controls {
		justify-content: flex-start;
	}
}

@media screen and (max-width: 900px) {
	.report-statistics-page {
		padding: 12px;
	}

	.report-statistics-page .report-filter-head,
	.report-statistics-page .report-table-head {
		align-items: flex-start;
		flex-direction: column;
	}

	.report-statistics-page .report-filter-controls {
		grid-template-columns: 1fr;
	}

	.report-statistics-page .report-filter-range,
	.report-statistics-page .report-date-picker.el-date-editor--datetimerange.el-input__inner,
	.report-statistics-page .report-action-controls {
		width: 100%;
	}

	.report-statistics-page .report-action-controls button,
	.report-statistics-page .report-action-controls .el-button {
		flex: 1;
	}
}
</style>
